import { css } from 'styled-components';

export const wordBreak = css`
  overflow-wrap: break-word;
  word-break: break-word;
  word-wrap: break-word;
`;
